import { useState, useEffect } from "react";

const Splash = () => {
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    document.body.style.backgroundColor = "#000";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  const handleGetStarted = () => {
    // Only open mailto in a new window
    window.open("mailto:nathan@mediatruck.com?subject=MEDIA%20TRUCK%20Inquiry&body=I'm%20interested%20in%20learning%20more%20about%20your%20truck%20media%20services.", "_blank");
  };

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-black p-4">
      <div className="w-full max-w-md flex flex-col items-center space-y-16">
        {/* Logo */}
        <div className="w-full max-w-[320px]">
          <img src="/logo.png" alt="MEDIA TRUCK Logo" className="w-full" />
        </div>

        {/* Button */}
        <button
          onClick={handleGetStarted}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onFocus={() => setIsHovered(true)}
          onBlur={() => setIsHovered(false)}
          className="relative group"
        >
          <div className={`
            absolute inset-0 rounded-full bg-[rgb(43,224,47)] 
            ${isHovered ? 'blur-lg opacity-70' : 'blur-md opacity-50'} 
            transition-all duration-300 transform
            ${isHovered ? 'scale-110' : 'scale-100'}
          `}></div>

          <div className={`
            relative px-12 py-5 rounded-full font-bold text-2xl
            text-white bg-[rgb(43,224,47)] 
            transition-all duration-300 shadow-lg
            ${isHovered ? 'shadow-[rgb(43,224,47)]/50' : 'shadow-[rgb(43,224,47)]/30'} 
            border-2 border-[rgb(43,224,47)]/80
            overflow-hidden flex items-center justify-center
          `}>
            <span className="z-10 relative tracking-wide">GET STARTED</span>
            <div className={`
              absolute top-0 left-0 right-0 h-full w-full
              bg-linear-to-r from-transparent via-white/30 to-transparent
              transition-all duration-700 ease-in-out
              ${isHovered ? '-translate-x-0' : '-translate-x-full'}
            `}></div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default Splash;
